import React from 'react';
import { Link } from 'react-router-dom';
import { CASTING } from '@/constants/testIds';
import { Briefcase, MapPin, Clock, IndianRupee } from 'lucide-react';

const CastingCard = ({ casting }) => (
  <Link
    to={`/castings/${casting.casting_id}`}
    data-testid={CASTING.card}
    className="block rounded-2xl border border-white/10 bg-[#13182C] p-6 card-glow group"
  >
    <div className="flex items-center justify-between mb-3">
      <span className="text-[11px] uppercase tracking-widest text-emerald-300 flex items-center gap-1">
        <Briefcase className="h-3.5 w-3.5" /> {casting.role_type}
      </span>
      <span className="text-[10px] uppercase tracking-wider px-2 py-1 rounded-full bg-amber-400/15 text-amber-300">
        {casting.status || 'Open'}
      </span>
    </div>
    <h3 className="font-display text-lg text-white font-semibold leading-snug mb-2 group-hover:text-fuchsia-200 transition">
      {casting.title}
    </h3>
    <p className="text-sm text-slate-400 line-clamp-2 mb-4">{casting.description}</p>
    <div className="grid grid-cols-3 gap-3 text-xs text-slate-300 pt-4 border-t border-white/5">
      <div className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-cyan-300" />{casting.location}</div>
      <div className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-fuchsia-300" />{casting.deadline}</div>
      <div className="flex items-center gap-1.5"><IndianRupee className="h-3.5 w-3.5 text-amber-300" />{casting.budget || '—'}</div>
    </div>
  </Link>
);

export default CastingCard;
